export default __webpack_public_path__ + "static/media/materialUi_logo.5b2d8a0a.png";